module.exports = __webpack_public_path__ + "static/img/customer_service.6b6a9927.png";